export default "__VITE_ASSET__D2dGz7Hq__"